var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"clear":"both"}}),_c('one-brand-display'),_c('two-sightseeing',{attrs:{"title":"观光农业"}}),_c('three-server'),_c('five-links')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }